import { gql } from '@apollo/client';

import { cartPartial, subscriptionPartial } from '../partials';

export const repeatOrder = gql`
  mutation adding($items: [CartItemInput]) {
    fillCart(input: { items: $items }) {
      ${cartPartial(subscriptionPartial)}
      cartErrors {
        reasons
      }
    }
  }
`;
